import React from 'react';
import { NavigationContainer } from '@react-navigation/native';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import Home from './screens/home'
import Viewer from './screens/viewer';
import Lessons from './screens/lessons';
import Dictionary from './screens/dictionary';
import DictionaryPage from './screens/dictionary-page';
import AdvancedSearch from './screens/advanced-search';
import Tests from './screens/tests';
import Exercises from './screens/exercises';
import About from './screens/about';
import AboutOlonkho from './screens/about-olonkho';
import AboutOlonkhosut from './screens/about-olonkhosut';
import { oStyles } from './olonkho-styles';

const Stack = createNativeStackNavigator();

export default function Navigate() {
    return (
        <NavigationContainer>
            <Stack.Navigator>
                <Stack.Screen 
                    name="Home" 
                    component={Home}
                    options={ { 
                        title: "Главная страница", 
                        headerStyle: oStyles.default_header,
                        headerTitleStyle: { fontFamily: 'futuris' },
                        headerTintColor: 'white',
                    } }
                    />
                <Stack.Screen
                    name="Viewer"
                    component={Viewer}
                    options={ { 
                        title: "Текст олонхо",
                        headerStyle: oStyles.default_header,
                        headerTitleStyle: { fontFamily: 'futuris' },
                        headerTintColor: 'white',
                    } }
                    />
                <Stack.Screen
                    name="Lessons"
                    component={Lessons}
                    options={ {
                        title: "Практические занятия", 
                        headerStyle: oStyles.default_header,
                        headerTitleStyle: { fontFamily: 'futuris' },
                        headerTintColor: 'white',
                    } }
                    />
                <Stack.Screen
                    name="Dictionary"
                    component={Dictionary}
                    options={ {
                        title: "Словари", 
                        headerStyle: oStyles.default_header,
                        headerTitleStyle: { fontFamily: 'futuris' },
                        headerTintColor: 'white',
                    } }
                    />
                <Stack.Screen
                    name="DictionaryPage"
                    component={DictionaryPage}
                    options={ {
                        title: "Словарь", 
                        headerStyle: oStyles.default_header,
                        headerTitleStyle: { fontFamily: 'futuris' },
                        headerTintColor: 'white',
                    } }
                    />
                <Stack.Screen
                    name="AdvancedSearch"
                    component={AdvancedSearch}
                    options={ {
                        title: "Расширенный поиск", 
                        headerStyle: oStyles.default_header,
                        headerTitleStyle: { fontFamily: 'futuris' },
                        headerTintColor: 'white',
                    } }
                    />
                <Stack.Screen
                    name="Tests"
                    component={Tests}
                    options={ {
                        title: "Тесты", 
                        headerStyle: oStyles.default_header,
                        headerTitleStyle: { fontFamily: 'futuris' },
                        headerTintColor: 'white',
                    } }
                    />
                <Stack.Screen
                    name="Exercises"
                    component={Exercises}
                    options={ {
                        title: "Контекстные задания", 
                        headerStyle: oStyles.default_header,
                        headerTitleStyle: { fontFamily: 'futuris' },
                        headerTintColor: 'white',
                    } }
                    />
                <Stack.Screen 
                    name="About" 
                    component={About}
                    options={ {
                        title: "О проекте",
                        headerStyle: oStyles.default_header,
                        headerTitleStyle: { fontFamily: 'futuris' },
                        headerTintColor: 'white',
                    } }
                    />
                <Stack.Screen 
                    name="AboutOlonkho" 
                    component={AboutOlonkho}
                    options={ {
                        title: "Что такое олонхо?",
                        headerStyle: oStyles.default_header,
                        headerTitleStyle: { fontFamily: 'futuris' },
                        headerTintColor: 'white',
                    } }
                />
                <Stack.Screen 
                    name="AboutOlonkhosut" 
                    component={AboutOlonkhosut}
                    options={ {
                        title: "Олонхосут И.И. Бурнашев – Тонг Суорун",
                        headerStyle: oStyles.default_header,
                        headerTitleStyle: { fontFamily: 'futuris' },
                        headerTintColor: 'white',
                    } }
                />
            </Stack.Navigator>
        </NavigationContainer>
    );
}